import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'

import Box from 'suitTheme/Box'
import styles from './styles.scss'

const ListItem = React.forwardRef((props, ref) => {
  const {
    borderColor,
    boxProps,
    children,
    disableHover,
    flexDirection,
    forceBottomBorder,
    forwardProps,
    href,
    isDragging,
    listBorderRadius,
    onClick,
    showAngleIcon,
    style,
  } = props

  return (
    <Box
      {...boxProps} // Needs to come first so borderColor is applied correctly
      borderColor={borderColor || 'lineColor'}
      className={classnames(
        styles.root,
        listBorderRadius ? styles.listBorderRadius : null,
        !forceBottomBorder ? styles.hideLastChildBottomBorder : null,
        !disableHover ? styles.hoverStyle : null,
        isDragging ? styles.dragging : null,
      )}
      flexDirection={flexDirection || 'row'}
      href={href}
      onClick={onClick}
      paddingRight={showAngleIcon ? 'xlarge' : null}
      position="relative"
      ref={ref}
      style={style}
      {...forwardProps}
    >
      {children}

      {showAngleIcon && <FontAwesomeIcon className={styles.angleRight} icon={faAngleRight} />}
    </Box>
  )
})

ListItem.propTypes = {
  as: PropTypes.string,
  borderColor: PropTypes.string,
  boxProps: PropTypes.object,
  children: PropTypes.node,
  disableHover: PropTypes.bool,
  flexDirection: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  forceBottomBorder: PropTypes.bool,
  forwardProps: PropTypes.object,
  href: PropTypes.string,
  isDragging: PropTypes.bool,
  listBorderRadius: PropTypes.bool,
  onClick: PropTypes.func,
  padding: PropTypes.string,
  showAngleIcon: PropTypes.bool,
  style: PropTypes.object,
}

export default ListItem
